import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { CustomList } from "components";
import { EvtHeader, EvtSectionHeader } from "components/header";

import { JobTotalAllocatedHoursStat } from "components/job/stats/allocated/stat";

import { useJob } from "@/modules/work/jobs/context";
import { HoursCell, TotalHoursCell } from "@/components/hours/cell";
import { useProject } from "@/modules/work/projects/context";
import Loader from "@/components/loader";
import { EvtStatsCard } from "components/stats/display-card";
import JobTimesheetEmployeesFilters from "@/modules/work/jobs/timesheet/employees/filters";
import { DisplayHours } from "components/display/hours";
import { RenderProfile } from "components/render-profile";

export default function JobTimesheetEmployees() {
  const [totals, setTotals] = useState(null);

  const { jobId } = useParams();
  const { type, project } = useJob();

  const isFixedOrDedicated = ["fixed", "dedicated"].includes(type);

  const isHourlyOrBucket = ["hourly", "bucket"].includes(type);

  const columns = [
    {
      id: "employee",
      accessorKey: "employee",
      header: "Employee",
      cell: ({ getValue }) => {
        return <RenderProfile user={getValue()} />;
      },
      footer: "Total",
    },
    {
      id: "department",
      accessorKey: "department.name",
      header: "Department",
    },
    {
      id: "grade",
      accessorKey: "grade.name",
      header: "Grade",
    },
    ...(isHourlyOrBucket
      ? [
        {
          id: "billable_hours",
          accessorKey: "billable_hours",
          header: "Billable",
          cell: HoursCell,
          footer: TotalHoursCell("billable_hours"),
        },
      ]
      : []),
    ...(isFixedOrDedicated
      ? [
        {
          id: "consumed_hours",
          accessorKey: "consumed_hours",
          header: "Consumed",
          cell: HoursCell,
          footer: TotalHoursCell("consumed_hours"),
        },
      ]
      : []),
    {
      id: "approved_hours",
      accessorKey: "approved_hours",
      header: "Approved",
      cell: HoursCell,
      footer: TotalHoursCell("approved_hours"),
    },
    ...(isFixedOrDedicated
      ? [
        {
          id: "spent_hours",
          accessorKey: "spent_hours",
          header: "Spent",
          cell: HoursCell,
          footer: TotalHoursCell("spent_hours"),
        },
      ]
      : []),
    {
      id: "logged_hours",
      accessorKey: "logged_hours",
      header: "Logged",
      cell: HoursCell,
      footer: TotalHoursCell("logged_hours"),
    },
    {
      id: "unapproved_hours",
      accessorKey: "unapproved_hours",
      header: "Unapproved",
      cell: HoursCell,
      footer: TotalHoursCell("unapproved_hours"),
    },
    {
      id: "unreviewed_hours",
      accessorKey: "unreviewed_hours",
      header: "Unreviewed",
      cell: HoursCell,
      footer: TotalHoursCell("unreviewed_hours"),
    },

    {
      id: "reviewer",
      accessorKey: "reviewer",
      header: "Reviewer",
      cell: ({ getValue }) => {
        return <RenderProfile user={getValue()} />;
      },
    },
  ];

  const defaultFilters = {
    jobId,
    projectId: project.id,
  };

  const exportFields = [
    "employee.first_name",
    "employee.last_name",
    "department",
    "logged",
    ...(isFixedOrDedicated ? ["spent"] : []),
    "approved",
    ...(isFixedOrDedicated ? ["consumed"] : []),
    "unreviewed",
    "reviewer.first_name",
    "reviewer.last_name",
  ];

  return (
    <div className="flex-1 overflow-auto" key={defaultFilters}>
      {/* <EvtHeader title="Employees" /> */}
      {/* <section>
        <EvtSectionHeader title="Budget" />
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 px-4 gap-4 md:px-6 mt-2.5">
          {type === "fixed" && <JobTotalAllocatedHoursStat id={jobId} />}
          <EvtStatsCard
            label="Consumed"
            value={<DisplayHours value={totals?.consumed} />}
          />
          <EvtStatsCard
            label="Spent"
            value={<DisplayHours value={totals?.spent} />}
          />
        </div>
      </section> */}

      <CustomList
        storageKey={`${jobId}-${project.id}`}
        title="Employees"
        endPoint="custom-ui/get-employee-wise-timesheet-summary-for-project"
        export={true}
        fields={exportFields}
        filters={defaultFilters}
        columns={columns}
        hidePagination={true}
        onDataChange={(response) => setTotals(response.meta?.totals)}
        renderFilters={JobTimesheetEmployeesFilters}
        teleportFilters={true}
        getRowClassName={(row) =>
          row?.is_allocated === false ? "bg-red-50 hover:bg-red-100/60" : ""
        }
      />
    </div>
  );
}
